import { BB1, BB2, BB3, Female1, InTheN1, InTheN2, InTheN3, InTheN4, LS1, LS2, LS3, LS4, Male1, Male2, NRVideo, SC1, SC2 } from "./constant";
import {
  DashboardImg,
  DashboardImage1,
  DashboardImage2,
  DashboardImage3,
  DashboardImage4,
} from "./constant";
import DashboardIcon from '@mui/icons-material/Dashboard';

export const formatText = (text = "") => {
  return text
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const teamMemberData = [
  {
    id: 1,
    name: "Abhinav Singh",
    designation: "Frontend Developer",
    image: Female1,
    about: '"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."',
  },
  {
    id: 2,
    name: "Dipanshu Goel",
    designation: "Sr. UI/UX Designer",
    image: Male2,
    about: '"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."',
  },
  {
    id: 1,
    name: "Raunak Kumar",
    designation: "Frontend Developer",
    image: Female1,
    about: '"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."',
  },

  {
    id: 3,
    name: "Firoj Khan",
    designation: "Devops Engineer",
    image: Male2,
    about: '"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."',
  },
  {
    id: 4,
    name: "Rahul Yadav",
    designation: "Sr. Full Stack Developer",
    image: Male1,
    about: '"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."',
  },
  {
    id: 5,
    name: "Shubham k",
    designation: "AI Engineer",
    image: Female1,
    about: '"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."',
  },
  {
    id: 6,
    name: "Yash Tiwari",
    designation: "Backend Developer",
    image: Male2,
    about: '"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."',
  },
  {
    id: 7,
    name: "Naman Kumar",
    designation: "Backend Developer",
    image: Male2,
    about: '"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."',
  },
  {
    id: 8,
    name: "Sumit Singh",
    designation: "Backend Developer",
    image: Male2,
    about: '"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."',
  },
  {
    id: 9,
    name: "Asmith Gupta",
    designation: "Flutter Developer",
    image: Female1,
    about: '"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."',
  },
  {
    id: 10,
    name: "Ajay Pal",
    designation: "Sr. Flutter Developer",
    image: Female1,
    about: '"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."',
  },

];

export const inTheNewsOptions = [
  "Empowering your operations with intelligent dashboards for real-time insights and smart decisions",
  "Empowering your operations with intelligent dashboards for real-time insights and smart decisions",
  "Empowering your operations with intelligent dashboards for real-time insights and smart decisions",
  "Empowering your operations with intelligent dashboards for real-time insights and smart decisions",
];

export const newsData = [
  {
    title: "Empowering your operations with intelligent dashboards for real-time insights and smart decisions",
    category: "AI Integration",
    date: "Nov 07, 2024",
    imageUrl: InTheN1,
  },
  {
    title: "Empowering your operations with intelligent dashboards for real-time insights and smart decisions",
    category: "AI Integration",
    date: "Nov 07, 2024",
    imageUrl: InTheN2,
  },
  {
    title: "Empowering your operations with intelligent dashboards for real-time insights and smart decisions",
    category: "AI Integration",
    date: "Nov 07, 2024",
    imageUrl: InTheN4,
  },
  {
    title: "Empowering your operations with intelligent dashboards for real-time insights and smart decisions",
    category: "AI Integration",
    date: "Nov 07, 2024",
    imageUrl: InTheN3,
  },
  {
    title: "Empowering your operations with intelligent dashboards for real-time insights and smart decisions",
    category: "AI Integration",
    date: "Nov 07, 2024",
    imageUrl: InTheN4,
  },
  {
    title: "Empowering your operations with intelligent dashboards for real-time insights and smart decisions",
    category: "AI Integration",
    date: "Nov 07, 2024",
    imageUrl: InTheN2,
  },
];

export const newsBreakingBoundaryData = {
  thoughtLeadership: [
    {
      id: 1,
      title: "Thought Leadership Insights",
      description: "Pop everything onto a baking sheet and roast it all together. This dish is healthy, easy to clean up, and can be made with various veggies.",
      image: LS4,
    },
    {
      id: 2,
      title: "Thought Leadership Insights",
      description: "Pop everything onto a baking sheet and roast it all together. This dish is healthy, easy to clean up, and can be made with various veggies.",
      image: LS3,
    }
  ],
  dashboards: [
    {
      id: 1,
      description: "Empowering your operations with intelligent dashboards for real-time insights and smarter decisions.",
      image: LS1,
    },
    {
      id: 2,
      description: "Empowering your operations with intelligent dashboards for real-time insights and smarter decisions.",
      image: LS2,
    },
    {
      id: 3,
      description: "Empowering your operations with intelligent dashboards for real-time insights and smarter decisions.",
      image: LS2,
    },
    {
      id: 4,
      description: "Empowering your operations with intelligent dashboards for real-time insights and smarter decisions.",
      image: LS1,
    }
  ]
};



export const newCarauselData = [
  {
    id: 1,
    timeline: `#AI Integration`,
    date: `Nov 07, 2024`,
    title: `Thought Leadership Insights`,
    desc: `Pop everything onto a baking sheet and roast it all together. This dish is healthy, easy to clean up, and can be made with various veggies depending on what’s in season.`,
    image: BB1
  },
  {
    id: 2,
    timeline: `#AI Integration`,
    date: `Nov 07, 2024`,
    title: `A Partnership for Progress`,
    desc: `Pop everything onto a baking sheet and roast it all together. This dish is healthy, easy to clean up, and can be made with various veggies depending on what’s in season.`,
    image: BB2
  },
  {
    id: 3,
    timeline: `#AI Integration`,
    date: `Nov 07, 2024`,
    title: `Awarded SaaS Innovatorof the Year`,
    desc: `Pop everything onto a baking sheet and roast it all together. This dish is healthy, easy to clean up, and can be made with various veggies depending on what’s in season.`,
    image: BB3
  },
  {
    id: 4,
    timeline: `#AI Integration`,
    date: `Nov 07, 2024`,
    title: `Who We Are: Innovators in Smarter Solutions.`,
    desc: `Pop everything onto a baking sheet and roast it all together. This dish is healthy, easy to clean up, and can be made with various veggies depending on what’s in season.`,
    image: BB1
  },
  {
    id: 5,
    timeline: `#AI Integration`,
    date: `Nov 07, 2024`,
    title: `Awarded SaaS Innovatorof the Year`,
    desc: `Pop everything onto a baking sheet and roast it all together. This dish is healthy, easy to clean up, and can be made with various veggies depending on what’s in season.`,
    image: BB2
  },
]

export const jobListings = [
  { id: 1, role: "Product Designer", department: "Design", time: "Full-time", location: "In-Office" },
  {
    id: 2,
    role: "Front-End Developer",
    department: "Development",
    time: "Part-Time",
    location: "In-Office"
  },
  {
    id: 3,
    role: "Front-End Developer",
    department: "Development",
    time: "Part-Time",
    location: "In-Office"
  },
  { id: 4, role: "Product Designer", department: "Design", time: "Part-Time", location: "In-Office" },
  { id: 5, role: "Product Designer", department: "Design", time: "Part-Time", location: "In-Office" },
  { id: 6, role: "Product Designer", department: "Design", time: "Part-Time", location: "In-Office" },
];

export const getTwitterPosts = [
  "https://twitter.com/iEnergyDigital/status/1319898557277589505",
  "https://twitter.com/iEnergyDigital/status/1231263527056310272",
  "https://twitter.com/iEnergyDigital/status/1039172532421709824",
  "https://twitter.com/iEnergyDigital/status/1010217680551358464"
];

export const getLinkedinPosts = [
  { url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7229537328950599681", postUrl: "https://www.linkedin.com/posts/neerajgupta2905_transformation-one-netzero-activity-7229537329772736513-V6fk" },
  { url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7229537328950599681", postUrl: "https://www.linkedin.com/posts/neerajgupta2905_transformation-one-netzero-activity-7229537329772736513-V6fk" },
  { url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7229537328950599681", postUrl: "https://www.linkedin.com/posts/neerajgupta2905_transformation-one-netzero-activity-7229537329772736513-V6fk" },
]




export const avalancheFeatures = [
  {
    cardTitle: "AVALANCHE.",
    cardSubtitle: "Enterprise risk intelligence platform transforming uncertainty into informed decisions, resilience, business confidence, and organizational preparedness.",
    slideSection: [{
      title: "Enterprise Risk Management",
      icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
      mainImage: DashboardImage1,
      text: "Identify, assess, monitor, and mitigate strategic, operational, and business risks."
    },
    {
      title: "Risk Analytics & Insights",
      icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
      mainImage: DashboardImage2,
      text: "Analyze risk exposure, emerging threats, trends, and organizational vulnerabilities."
    },
    {
      title: "Governance & Compliance",
      icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
      mainImage: DashboardImage3,
      text: "Strengthen policy controls monitoring, regulatory adherence, and accountability."
    },
    {
      title: "Resilience & Decision Support",
      icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
      mainImage: DashboardImage4,
      text: "Enable proactive risk response, scenario planning, and business continuity preparedness."
    },
    ],
  },
  {
    cardTitle: "One.",
    cardSubtitle:
      "Unify workforce productivity, sales, HR, onboarding, compliance, and business workflows in a single AI-powered platform designed to improve visibility, accountability, and performance across your organization.",
    slideSection: [
      {
        title: "AI-Powered Workforce Productivity",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage1,
        text: "Monitor employee performance, attendance, activities, operational and tasks efficiency."
      },
      {
        title: "Sales CRM & Customer Management",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage2,
        text: "Track opportunities, customer interactions, pipelines, and revenue efficiently."
      },
      {
        title: "HRMS & Employee Lifecycle",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage3,
        text: "Manage recruitment, onboarding, attendance, payroll, appraisals, training, and engagement."
      },
      {
        title: "Labour Compliance & Governance",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage4,
        text: "Stay compliant with contractors, labour laws, statutory filings, audits and regulations."
      }
    ]
  },

  
  {
    cardTitle: "VISVA.",
    cardSubtitle:
      "Turn enterprise information into actionable industry insights with AI using the power of RAG and multiple LLMs.",
    slideSection: [
      {
        title: "Enterprise Knowledge Intelligence",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage1,
        text: "Unify structured and unstructured data for contextual AI-driven knowledge access."
      },
      {
        title: "RAG-Powered Search & Discovery",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage2,
        text: "Deliver accurate responses grounded in enterprise documents, systems, and records."
      },
      {
        title: "Generative AI Assistants",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage3,
        text: "Deploy domain-specific AI copilots for operations, engineering, and compliance."
      },
      {
        title: "LLM Governance & Automation",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage4,
        text: "Manage AI workflows, prompt orchestration, model governance, and business automation."
      }
    ]
  },
  {
    cardTitle: "AURORA.",
    cardSubtitle:
      "Aurora connects workers, machines, and operations through a unified digital execution platform.",
    slideSection: [
      {
        title: "Connected Workforce",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage1,
        text: "Digitize workforce collaboration, tasks, accountability with AI-guided decision support."
      },
      {
        title: "Connected Machines",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage2,
        text: "Monitor equipment health, utilization and performance with predictive intelligence."
      },
      {
        title: "Smart Field Operations",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage3,
        text: "Standardize inspections, workflows, permits, field execution, and compliance."
      },
      {
        title: "Operational Intelligence",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage4,
        text: "Transform workforce and machine data into AI-powered insights and recommendations."
      }
    ]
  },
  {
    cardTitle: "ICEBERG.",
    cardSubtitle:
      "Unified IT-OT data platform connecting enterprise applications, industrial systems, assets, devices, and operational data across the organization.",
    slideSection: [
      {
        title: "Universal Connectivity",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage1,
        text: "Connect enterprise applications, industrial systems, IoT devices, and databases."
      },
      {
        title: "Data Integration & Orchestration",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage2,
        text: "Aggregate, transform, and synchronize information across diverse data sources."
      },
      {
        title: "Enterprise Data Governance",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage3,
        text: "Establish trusted, secure, and governed data across the organization."
      },
      {
        title: "Real-Time Data Foundation",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage4,
        text: "Enable analytics, AI, reporting, and operational applications with live data."
      }
    ]
  },
  {
    cardTitle: "Netzero.",
    cardSubtitle: "",
    slideSection: [
      {
        title: "AI-Powered EHS Management",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage1,
        text: "Incident, audits, permits, inspections, observations and actions in a single platform."
      },
      {
        title: "ESG & Sustainability Reporting",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage2,
        text: "Automate GRI, SASB, CSRD, BRSR, and TCFD disclosures with centralized ESG data management."
      },
      {
        title: "Carbon & NetZero Intelligence",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage3,
        text: "Track Scope 1, 2 & 3 emissions, energy consumption, climate initiatives and netzero targets."
      },
      {
        title: "Operational Risk & Compliance",
        icon: <DashboardIcon sx={{ color: '#6366F1' }} />,
        mainImage: DashboardImage4,
        text: "AI-driven risk analytics, workflows and enterprise compliance automation."
      }
    ]
  }
];


export const formattedShortDate = (date) => {
  if (!date) return "";

  return new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};